import React from 'react';
import { IProps as IWysiwygBlockProps } from './WysiwygBlock.interface';
import { WysiwygBlock } from './WysiwygBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

export interface IWysiwygBlockInputProps {
    columnLayout?: 'one-column' | 'two-column'; // Column layout toggle: default one-column
    /** @deprecated Use columnLayout. Supported for CMS backward compatibility. */
    layout?: 'one-column' | 'two-column';
    heading?: string; // Optional heading prop
    content?: string; // Optional content prop (first column / single column)
    base64EncodedText?: boolean; // If true, content is expected to be base64-encoded
    contentColumn2?: string; // Second column content when layout is two-column
    base64EncodedTextColumn2?: boolean; // If true, contentColumn2 is base64-encoded
    [key: string]: any; // Allow passthrough of other props, including BlockWrapper props
}

const mapInputToProps = (input: IWysiwygBlockInputProps): IWysiwygBlockProps => {
    const { layout: inputLayout, ...rest } = input;
    const columnLayout =
        input.columnLayout ??
        (inputLayout === 'one-column' || inputLayout === 'two-column' ? inputLayout : undefined) ??
        'one-column';
    return {
        columnLayout,
        heading: input.heading,
        text: input.content,
        base64EncodedText: input.base64EncodedText || false,
        textColumn2: input.contentColumn2,
        base64EncodedTextColumn2: input.base64EncodedTextColumn2 || false,
        ...rest, // Pass through BlockWrapper props (layout for BlockWrapper is in rest if CMS sent fullwidth/hero)
    };
};

const WysiwygBlockTranslation: React.FC<IWysiwygBlockInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={WysiwygBlock}
        mapProps={mapInputToProps}
    />
);

export default WysiwygBlockTranslation;
